export enum PageDirection {
    Left,
    Right,
}
